/**
 * Simple local development authentication bypass utilities
 */

/**
 * Checks if the application is running on localhost
 * @returns {boolean} True if running on localhost, false otherwise
 */
export const isLocalhost = () => {
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname === '[::1]';
};

/**
 * Checks if authentication bypass is enabled via environment variable
 * @returns {boolean} True if auth bypass is enabled, false otherwise
 */
export const isAuthBypassEnabled = () => {
  // Only enable bypass on localhost
  if (!isLocalhost()) {
    return false;
  }
  
  // Check environment variable AUTH_BYPASS
  return import.meta.env.VITE_AUTH_BYPASS === 'true';
};

/**
 * Gets dummy authentication data for local development
 * @returns {Object} Object containing dummy accessToken and userInfo
 */
export const getDummyAuthData = () => {
  return {
    accessToken: 'dev-dummy-token-local-development-bypass',
    userInfo: {
      userId: 'dev-user-123',
      username: 'dev-user',
      email: 'dev@healthcompass.local',
      firstName: 'Development',
      lastName: 'User',
      roles: ['PHARMACIST', 'ADMIN'],
      acceptedPrivacyPolicy: true,
      acceptedTermOfUse: true
    }
  };
};

/**
 * Sets up dummy authentication data in sessionStorage for local development
 */
export const setupDummyAuth = () => {
  if (isLocalhost() && isAuthBypassEnabled()) {
    const { accessToken, userInfo } = getDummyAuthData();
    
    // Set dummy data in sessionStorage
    sessionStorage.setItem('accessToken', accessToken);
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    
    return true;
  }
  return false;
};

/**
 * Cleans up dummy authentication data
 */
export const cleanupDummyAuth = () => {
  const accessToken = sessionStorage.getItem('accessToken');
  if (accessToken === 'dev-dummy-token-local-development-bypass') {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('userInfo');
  }
};
